// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"200":"c296708d","855":"ea27aec1"}[chunkId] + ".chunk.css";
};